/**
 * ดาบชักเร็วโคมเหล็ก (quick-draw-sabre): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.3, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 5). The lock move is sp-verdict 判 (range 2.1, the 0.35 s lock wind-up:
 * sabre sheathed, the thumb pushes the guard one notch — a 1-px gleam of blade — knees sink). Re-themed (user Q2, DECISIONS
 * 2026-10-13): quick-draw + lightning daze, no bleed. sp-verdict's own cut cashes out the foe's อัสนีชา (`perTargetStack`);
 * the routine is three draws from three sides (the third `pass`es through to stand back to back), the slow sheathe, then the
 * fourth, full draw with the lightning; the foe is let go with two stacks of อัสนีชา (`endStatus`): one more draw stuns.
 * Identity: draw–sheathe rhythm, lines that appear a beat AFTER each draw, instant repositioning; vs jy-cross (its sect's other
 * sabre: an open flurry). Keys (sp* poses, draw/verdict fx, draw/sheathe/thunder sfx) are the contract for the motion / FX /
 * sound lanes: drawLine = a 1-px bright line on the foe 0.15 s after the draw, then a 2-px spark crackle (no blood). Data only.
 */
import { registerLongMove } from './registry';

/** 判 สามคำพิพากษา — draw left, draw right, draw through to its back, the slow sheathe, the thunder draw, the flick home. */
export const THREE_VERDICTS = registerLongMove({
  skillId: 'sp-verdict',
  kind: 'lock',
  name: 'สามคำพิพากษา',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.0,
  catch: 0.4,
  power: 2.3,
  lunge: 1.2,
  endStatus: { status: 'thunder-daze', dur: 5, stacks: 2 },
  beats: [
    { at: 0, pose: 'spThumb', hits: 0, share: 0, foe: 'hit', fx: 'lanternGlint', sfx: 'guardClick', cam: 'hold' },
    { at: 0.4, pose: 'spDrawL', hits: 1, share: 0.14, foe: 'hit', ai: 2, fx: 'drawLine', sfx: 'drawSnap' },
    { at: 1.2, pose: 'spDrawR', hits: 1, share: 0.14, foe: 'hit', ai: 2, fx: 'drawLine', sfx: 'drawSnap2', cam: 'orbit' },
    {
      at: 2.0,
      pose: 'spDrawBack',
      hits: 1,
      share: 0.14,
      foe: 'spin',
      move: { kind: 'pass', dist: 2.6 },
      ai: 2,
      fx: 'drawLine',
      sfx: 'drawSnap3',
    },
    { at: 2.8, pose: 'spSeal', hits: 0, share: 0, foe: 'kneel', fx: 'verdictMark', sfx: 'sheatheSlow', cam: 'push' },
    {
      at: 3.6,
      pose: 'spSentence',
      hits: 1,
      share: 0.58,
      foe: 'knock',
      dist: 1.6,
      stop: 0.12,
      fx: 'sentenceBurst',
      sfx: 'thunderDraw',
      cam: 'shake',
    },
    { at: 4.3, pose: 'spFlickSheathe', hits: 0, share: 0, foe: 'fall', sfx: 'sheatheClick' },
    { at: 4.6, pose: 'spStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
